import { render, staticRenderFns } from "./ProfileInfo.vue?vue&type=template&id=19cc6fa2&"
import script from "./ProfileInfo.vue?vue&type=script&lang=js&"
export * from "./ProfileInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\RobertWiberg\\source\\repos\\server-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19cc6fa2')) {
      api.createRecord('19cc6fa2', component.options)
    } else {
      api.reload('19cc6fa2', component.options)
    }
    module.hot.accept("./ProfileInfo.vue?vue&type=template&id=19cc6fa2&", function () {
      api.rerender('19cc6fa2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Layout/ProfileInfo.vue"
export default component.exports